import {dataHooks} from '@wix/data-hooks'

export const paymentTokenizationDataHooks = dataHooks<{
  paymentPolicyLink: {}
}>('payment-tokenization')
